<template>
  <v-main>
    <v-card-title class="fixed-toolbar-bar">
      <gluid-editor-toolbar :editor="editor" />
      <v-text-field v-model="activeDocumentTitle" label="Title" flat dense />
    </v-card-title>
    <v-card-text style="height: 470px; overflow-y: auto">
      <editor-content :editor="editor" />
    </v-card-text>
    <v-btn
      bottom
      color="red darken-4"
      dark
      fab
      fixed
      right
      @click="saveActiveDocumentAndReplaceIfNeeded"
    >
      <!--      Hierboven maak methode in de component "saveActiveDocumentAndRedirectIfNeeded"-->
      <v-icon>mdi-content-save</v-icon>
    </v-btn>
  </v-main>
</template>

<script>
import GluidEditorToolbar from "@/components/editor/GluidEditorToolbar";

import { EditorContent } from "@tiptap/vue-2";
import GluidTipTapEditorInstance from "./GluidTipTapEditorInstance";

import store from "@/store";
import router from "@/router";
import { mapGetters } from "vuex";

export default {
  components: {
    EditorContent,
    GluidEditorToolbar,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editor: null,
      editorJSON: null,
      editorHTML: null,
    };
  },
  watch: {
    value(value) {
      const isSame = this.editor.getHTML() === value;
      if (isSame) {
        return;
      }

      this.editor.commands.setContent(this.value, false);
    },
    activePath(value) {
      router.replace(`/${value}`).catch(() => {});
    },
    activeDocumentJsonDoc(jsonDoc) {
      this.editor.commands.setContent(jsonDoc, false);
    },
  },

  mounted() {
    this.editor = GluidTipTapEditorInstance(true, true);
    this.editor.commands.setContent(this.activeDocumentJsonDoc);
  },
  methods: {
    async saveActiveDocumentAndReplaceIfNeeded() {
      const editorHTML = this.editor.getHTML();
      const editorJSON = this.editor.getJSON();
      await store.dispatch("saveActiveDocument", {
        editorHTML: editorHTML,
        editorJSON: editorJSON,
        path: this.$route.path,
      });
    },
  },
  computed: {
    ...mapGetters(["activeDocumentJsonDoc", "activeSpacePaths"]),
    activeDocumentTitle: {
      get() {
        if (store.state.activeSpace) {
          return store.state.activeDocumentTitle;
        }
        return null;
      },
      set(value) {
        store.state.activeDocumentTitle = value;
      },
    },
  },
};
</script>

<style lang="scss">
/* Basic editor styles */
.ProseMirror {
  margin-top: 1rem;

  > * + * {
    margin-top: 0.75em;
  }

  ul,
  ol {
    padding: 0 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
  }

  code {
    background-color: rgba(#616161, 0.1);
    color: #616161;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    font-family: "JetBrainsMono", monospace;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      background: none;
      font-size: 0.8rem;
    }
  }

  mark {
    background-color: #faf594;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.1);
    margin: 2rem 0;
  }
}

.ProseMirror {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;

    td,
    th {
      min-width: 1em;
      border: 2px solid #ced4da;
      padding: 3px 5px;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      font-weight: bold;
      text-align: left;
      background-color: #f1f3f5;
    }

    .selectedCell:after {
      z-index: 2;
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(200, 200, 255, 0.4);
      pointer-events: none;
    }

    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: -2px;
      width: 4px;
      background-color: #adf;
      pointer-events: none;
    }
  }
}

.tableWrapper {
  overflow-x: auto;
}

.resize-cursor {
  cursor: col-resize;
}
.ProseMirror-focused {
  outline: none;
}

.v-card__title.fixed-toolbar-bar {
  position: -webkit-sticky;
  position: sticky;
  top: 1.8rem;
  background-color: #fff;
  z-index: 2;
  margin-top: 20px;
}
</style>
